import { ROUTE_API } from "constant";
import { IBaseDataForPaginate } from "interfaces";
import { IGetLeadForPaginateInputModel, ILeadOutputModel } from "interfaces/lead";
import apiV3 from "utils/api.v3";

export const LeadServices = {
  getLead,
  deleteLead,
};

function getLead(data: IGetLeadForPaginateInputModel) {
  return apiV3.get<IBaseDataForPaginate<ILeadOutputModel>>({ url: ROUTE_API.LEAD_ROUTE.GET_LEAD, query: data });
}

function deleteLead(leadId: string) {
  return apiV3.delete({ url: ROUTE_API.LEAD_ROUTE.DELETE_LEAD.replace("{LEAD_ID}", leadId) });
}
